import { useMutation } from '@apollo/client';
import { useDispatch } from 'react-redux';
import { LOGIN_USER } from '../../apollo/mutations/user';
import { setAuthState, setAuthError } from '../../redux/slices/authSlice';
import AuthService from '../../auth/storage';
import { useNavigate } from 'react-router-dom';
import useAuthInitializer from './useAuthInitializer';
import extractErrorMessage from '../../utils/extractErrorMessage';

const useLogin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { runAuthBootstrap } = useAuthInitializer();

  const [loginMutation, { loading }] = useMutation(LOGIN_USER);

  const login = async ({ email, password }) => {
    try {
      const { data } = await loginMutation({ variables: { email, password } });

      if (!data?.loginUser) {
        throw new Error('Invalid login response.');
      }

      const { token, user } = data.loginUser;

      AuthService.storeToken(token);
      dispatch(setAuthState(user));
      await runAuthBootstrap();

      if (user.role === 'admin') {
        navigate('/admin');
      } else {
        navigate('/dashboard');
      }

      return { success: true };
    } catch (err) {
      dispatch(setAuthError(extractErrorMessage(err)));
      throw err;
    }
  };

  return { login, loading };
};

export default useLogin;